import { ValueType } from 'react-select';

import { SET_MERGE_INTERSECT_LAYERS } from '../../constants/appTypes';
import { IOptionsType } from '../../types/react-select-options';

const initialState: ValueType<IOptionsType> = [];

interface selectedMergeIntersectLayersAction {
  selectedLayers: ValueType<IOptionsType>;
  type: string;
}

export function selectedMergeIntersectLayers(state = initialState, action: selectedMergeIntersectLayersAction) {
  switch (action.type) {
    case SET_MERGE_INTERSECT_LAYERS:
      state = action.selectedLayers;
      return state;
    default:
      return state;
  }
}

export default selectedMergeIntersectLayers;
